import React from "react";

import { getPptxPreviewComponent } from "../helpers/custom_pptx_template";
import CsvPreview from "./csv_preview";
import DocxPreview from "./docx_preview";
import PdfPreview from "./pdf_preview";

const Preview = ({ config, setConfig, exportableProfiles, serializedProfile, index, avatar, logo }) => {
  const { exportTemplate, templateKey, order } = config;
  if (!serializedProfile) {
    return null;
  }

  const PreviewComponent = {
    pdf: PdfPreview,
    docx: DocxPreview,
    pptx: getPptxPreviewComponent(templateKey),
    csv: CsvPreview
  }[exportTemplate];

  if (!PreviewComponent) {
    return null;
  }
  return exportTemplate === "csv" ? (
    <PreviewComponent
      exportableProfiles={exportableProfiles}
      order={order}
      profileIndex={index}
      config={config}
      setConfig={setConfig}
    />
  ) : (
    <PreviewComponent profile={serializedProfile} order={order} config={config} avatar={avatar} logo={logo} />
  );
};

export default Preview;
